 // Chakra
import {
  Tr,
  Td,
  Tbody,
  Table,
  Skeleton
} from '@chakra-ui/react';

// Components
import Card from './Card/Card';
 
const TableSkeleton = ({ rowCount }) => {
  return (
    <Card padding="8px">
      <Table>
        <Tbody>
          {Array.from({ length: 5 }).map((_, i) => (
            <Tr key={i}>
              {Array.from({ length: rowCount }).map((_, i) => (
                <Td key={i} p={'16px 0 16px 24px'}>
                  <Skeleton height="20px" borderRadius="6px" />
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Card>
  );
};

export default TableSkeleton;